var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mappedRingGuidedContent)?_c('div',[_c('GuidedQuiz',_vm._b({attrs:{"results":_vm.mappedRingGuidedContent.results}},'GuidedQuiz',_vm.$attrs,false))],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }